import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'up-ui-copy-button',
  template: `
    <button
      *ngIf="label"
      class="button-copy"
      [attr.data-test]="id"
      [ngClass]="{ '--new-brand': newBrand }"
      [text]="label"
      upCopyButton
      (cbOnSuccess)="
        _snackBar.open('Conteúdo copiado', '', {
          duration: 3000
        })
      "
    >
      Copiar
    </button>
  `,
  styleUrls: ['./ui-copy-button.component.scss']
})
export class UiCopyButtonComponent {
  @ViewChild('tooltip', { static: true }) tooltip: MatTooltip;
  @Input() label: any;
  @Input() newBrand: boolean;
  @Input() id: string;

  constructor(public _snackBar: MatSnackBar) {}
}
